/* oxlint-disable react/refs -- imperative refs are required for DOM, focus, drag, and media behavior */
import { ReactElement, useRef, useState } from 'react'
import { LazyLocationCell } from '../LazyLocationCell'
import { LazyLocationPanel } from '../LazyLocationPanel'

/**
 * Component that shows a location name, integration status and address when hovered over
 * @Param locationId: string
 * @returns Component
 */
export function LazyLocationCard({ locationId }: { locationId?: string }): ReactElement {
  const [showLocationPanel, setShowLocationPanel] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  if (locationId === undefined) return <></>
  return (
    <div
      ref={ref}
      className="relative mx-2 flex h-full items-center align-middle text-body-xs"
      onMouseEnter={() => setShowLocationPanel(true)}
      onMouseLeave={() => setShowLocationPanel(false)}
    >
      <div className="overflow-hidden overflow-ellipsis whitespace-nowrap">
        <LazyLocationCell locationId={locationId} />
      </div>
      <LazyLocationPanel locationId={locationId} referenceElement={ref.current} isOpen={showLocationPanel} />
    </div>
  )
}
